export default __webpack_public_path__ + "static/media/maintainketosis@2x.d83c52b1.jpg";